export class GcpCloudSqlResourceStorageSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "diskType",
            "baseName": "diskType",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskSize",
            "baseName": "diskSize",
            "type": "number",
            "format": ""
        },
        {
            "name": "storageAutoResize",
            "baseName": "storageAutoResize",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpCloudSqlResourceStorageSettings.attributeTypeMap;
    }
    constructor() {
    }
}
